export default __webpack_public_path__ + "static/media/duplicate_selected.efd7d447.svg";